import React from 'react';
import { Paper, Box, Typography, Divider } from '@material-ui/core';
import { RequestProductItem } from './RequestProductItem';
import { formatMoney } from 'helpers/moneyFormatter';

function CustomerRequest({ children }) {
  return (
    <>
      <Paper elevation={1} component={Box} p={1}>
        {children}
      </Paper>
    </>
  );
}

CustomerRequest.Header = function CustomerRequestHeader({
  requestNumber,
  children,
}) {
  return (
    <Box
      p={1}
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}
    >
      <Typography variant="h6" component="h6">
        Pedido #{requestNumber}
      </Typography>

      {children}
    </Box>
  );
};

CustomerRequest.Info = function CustomerRequestInfo({ children }) {
  return (
    <>
      {children}
      <Divider />
    </>
  );
};

CustomerRequest.InfoData = function CustomerRequestInfoData({ children }) {
  return <Typography>{children}</Typography>;
};

CustomerRequest.InfoDataLabel = function CustomerRequestInfoDataLabel({
  children,
  style,
}) {
  return <b style={style}>{`${children}: `}</b>;
};

CustomerRequest.InfoDataText = function CustomerRequestInfoDataText({
  children,
}) {
  return <span style={{ textTransform: 'capitalize' }}>{children}</span>;
};

CustomerRequest.Content = function Content({ children }) {
  return (
    <Paper variant="outlined" component={Box} p={1} mb={2}>
      <Box p={1} display="flex" flexDirection="column">
        {children}
      </Box>
    </Paper>
  );
};

CustomerRequest.ProductList = function ProductList({ productList }) {
  return (
    <>
      {productList.map((productRequest) => (
        <RequestProductItem
          key={String(productRequest.id)}
          productRequest={productRequest}
        />
      ))}
    </>
  );
};

CustomerRequest.Footer = function CustomerRequestFooter({ totalPrice }) {
  return (
    <Box
      style={{
        display: 'flex',
        gap: '1rem',
      }}
      sx={{ pt: 1 }}
    >
      <Box>
        <Typography>
          <b>Preço Total: {formatMoney(totalPrice)}</b>
        </Typography>
      </Box>
    </Box>
  );
};

export { CustomerRequest };
